import React, { memo, useCallback, useMemo, useState } from 'react';
import { Stack, VStack } from '@adc/parallax-component-library';
import { InputErrorField, InputPassword, PasswordRequirements } from 'Components/utility';
const PasswordInputValidator = memo(({ placeholder, label, handleBlur, onChangeText, password, onValidate, errors, touched, passwordRules = [], testID, disabled, }) => {
    const [isBlurred, setIsBlurred] = useState(false);
    const [meetsPasswordRequirements, setMeetsPasswordRequirements] = useState(false);
    const onFocus = useCallback(() => {
        setIsBlurred(false);
    }, []);
    const filteredIdentities = useMemo(() => {
        const keysToFilter = ['min'];
        return passwordRules.filter(({ data: { key } }) => keysToFilter.includes(key));
    }, [passwordRules]);
    const requirements = useMemo(() => {
        return filteredIdentities.map(({ data, ...rest }) => {
            const match = new RegExp(data.regex).test(password.trim());
            const isInvalid = isBlurred && !match;
            return { match, isInvalid, data, ...rest };
        });
    }, [password, filteredIdentities, isBlurred]);
    const validatePassword = useCallback(() => {
        const remainingRequirements = requirements.filter((requirement) => !requirement.match);
        const meetsPasswordRequirements = !remainingRequirements.length;
        setMeetsPasswordRequirements(meetsPasswordRequirements);
        onValidate && onValidate(meetsPasswordRequirements);
    }, [requirements, onValidate]);
    const onBlur = useCallback((e) => {
        setIsBlurred(true);
        validatePassword();
        handleBlur(e);
    }, [handleBlur, validatePassword]);
    return (React.createElement(Stack, null,
        React.createElement(InputPassword, { isInvalid: (!meetsPasswordRequirements && isBlurred) ||
                (errors?.[testID] && touched?.[testID] ? true : false), placeholder: placeholder, label: label, testID: testID, onBlur: onBlur, onChangeText: onChangeText, defaultValue: password, onFocus: onFocus, disabled: disabled }),
        React.createElement(VStack, { marginTop: "$2" },
            React.createElement(PasswordRequirements, { requirements: requirements }),
            errors?.[testID] && touched?.[testID] && (React.createElement(InputErrorField, { errorMessage: errors?.[testID], testID: testID })))));
});
PasswordInputValidator.displayName = 'PasswordInputValidator';
export { PasswordInputValidator };
